export default "__VITE_ASSET__QPrQiVVn__"